<template>
  <div class="myAvailability">
    <loading
      :active.sync="isLoading"
      :can-cancel="true"
      color="#5bad2b"
      :is-full-page="fullPage"
    ></loading>
<br> <br>
    <div class="container availability mb-5" style="background:white;min-height: 500px;">
      <div class="timeupdate">
        <h4
          class="card-title d-flex justify-content-between align-items-center"
        >
          <h3 class="availablityheader" style="float:left ">Availability</h3>

<div id="activity">
  <span class="active" style="float:right" id="status" :class="{ 'green': isActive }">
          {{isActive ? 'Active' : 'InActive'}}
          <div
            style="display:inline; float:right"
            class="form-check form-switch"
          >
            <!-- toggle switch -->
            <div><label class="switch">
  <input @click="toggle"
              :checked="isActive" type="checkbox">
  <span class="slider round"></span>
</label></div>
          </div>
        </span>
<!-- <div class="form-group optionzone">
  <label for="Timezone" id="tmzone">TimeZone:</label>
                        <div class="form-select pull-right" style="width: 50%;">
                          <select @change="getZone()" v-model="myTimeZone"  class="form-control input-sm ">
                            <option id="selectvalue" v-for="data in timeZone"
            :key="data" :value="data.name">{{data.name}}</option>

                          </select>
                          <span class="select-icon"><i class="fa fa-chevron-down"></i></span>
                        </div>
                      </div> -->
</div>
        </h4>
      </div>
      <br>
        <div class="myAvailabilitybtn">
          <button @click="addAvaialablity()"  class="btn" style="background: #5bad2b; color:white">
            Add Availability</button
          >
        </div>
      <label for="date" class="listoftimes" v-for="(dayTime, index) in groupeddate" :key="index">
        <h1 class="datelist">{{ index }}</h1>
        <button
          type="button"
          class="timelist btn"
          v-for="(time, index1) in dayTime"
          :key="index1"
        >
          <span class="sctime">
            {{ time.start_time }} - {{ time.end_time }}
            <button
              class="btn delete"
              style="background : transparent ; float: right; all:unset; color:black "
              data-toggle="modal" data-target="#deleteModal"
              v-on:click="tempSkill(dayTime, time._id,index, index1)">
              <i class="fa fa-times"></i></button
          ></span></button
          ></label>
    </div>
    <div
        class="modal fade " id="deleteModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog deleteskillmodal" role="document">
          <div class="modal-content " style="width:50%;">
            <div class="modal-header">
              <h3 class="modal-title skilltitle" id="exampleModalLabel" style="text-align:center">Delete Availability  <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button></h3>

            </div>
            <div class="modal-body">
              <p>Are you sure to delete the Availability?</p>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                No
              </button>
              <button type="button" class="btn removeAvailability" v-on:click="removeSheduletime(tempId,tempIndex, tempIndex1)">
                Yes
              </button>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
import axios from 'axios'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { BaseURL } from '../../shared/classes'
import $ from 'jquery'
// import moment from 'moment'
import momentsone from 'moment-timezone'
export default {
  data () {
    return {
      fullPage: true,
      listDateTime: [],
      listDeleteTime: [],
      dataTime: [],
      userList: [],
      timeZone: [],
      myTimeZone: '',
      userTimezone: '',
      user_id: this.$route.params.id,
      isLoading: false,
      isActive: false,
      userstatus: false,
      status: [],
      getTimeZone: '',
      statusvalue: '',
      tempId: '',
      selectDay: '',
      currentTimeZone: momentsone.tz.guess(),
      groupeddate: []
    }
  },
  components: {
    Loading
  },
  created () {
    localStorage.getItem('user_id')
    // usertimezonelist
    axios
      .get(BaseURL + '/profile/get_timezonelist')
      .then(response => {
        this.timeZone = response.data.timezonelist
      })
    this.getAvailability()
  },
  methods: {
    addAvaialablity () {
      this.$router.push('/scheduleAvailability/' + this.user_id)
    },
    tempSkill (day, time, index, index1) {
      this.selectDay = day
      this.tempId = time
      this.tempIndex = index
      this.tempIndex1 = index1
    },
    removeSheduletime (time, index, index1) {
      this.selectDay.splice(index1, 1)
      $('#deleteModal').modal('hide')
      axios.get(BaseURL + '/profile/delete_user_availability/' + this.user_id + '/' + time + '/repeat').then(response => {
      })
      // alert('Are you sure you want to delete this time?')
      this.$awn.success('Availability Deleted Successfully')
    },
    getAvailability () {
      // get availability
      if (this.currentTimeZone === 'America/New_York') {
        this.timezone = 'EST'
      } else {
        this.timezone = 'IST'
      }
      axios.get(BaseURL + '/profile/get_user_availability_new/web/' + this.user_id + '/' + this.timezone).then(response => {
        this.isLoading = false
        this.listDateTime = response.data.availabilityDetails
        this.status = response.data.userAvailabilitystatusInfo
        // this.listDateTime.map(item => {
        //   item.list.map(time => {
        //     time.active = true
        //   })
        // })
        // convert
        const timezone = this.currentTimeZone
        for (let index = 0; index < this.listDateTime.length; index++) {
          // const Start = this.listDateTime[index].startdatetime_utc
          this.listDateTime[index].start_datetime = momentsone.utc(this.listDateTime[index].startdatetime_utc).tz(timezone).format('DD-MM-YYYY HH:mm a')
          this.listDateTime[index].startdate = momentsone.utc(this.listDateTime[index].startdatetime_utc).tz(timezone).format('DD-MMM-YYYY')
          this.listDateTime[index].start_time = momentsone.utc(this.listDateTime[index].startdatetime_utc).tz(timezone).format('hh:mm a')
          // const End = this.listDateTime[index].enddatetime_utc
          this.listDateTime[index].end_datetime = momentsone.utc(this.listDateTime[index].enddatetime_utc).tz(timezone).format('DD-MM-YYYY HH:mm a')
          this.listDateTime[index].end_time = momentsone.utc(this.listDateTime[index].enddatetime_utc).tz(timezone).format('hh:mm a')
        }
        this.groupBy(this.listDateTime, 'startdate')
        // convert
        this.getTimeZone = response.data.timezone
        if (this.getTimeZone === 'IST') {
          this.myTimeZone = this.timeZone[0].name
        } else {
          this.myTimeZone = this.timeZone[1].name
        }
        if (this.status === 'Active') {
          this.isActive = true
        } else {
          this.isActive = false
        }
        console.log(this.listDateTime)
      })
      this.isLoading = true
    },
    groupBy (array, key) {
      const result = {}
      this.groupeddate = []
      array.forEach(item => {
        if (!result[item[key]]) {
          result[item[key]] = []
          // this.groupeddate.push(item);
        }
        result[item[key]].push(item)
      })
      this.groupeddate = result
    },
    toggle () {
      // this.isActive = this.isActive
      this.isActive = !this.isActive
      if (this.isActive === true) {
        this.statusvalue = 'Active'
      } else {
        this.statusvalue = 'InActive'
      }
      const formData = new FormData()
      formData.append('availabilitystatus', this.statusvalue)
      const data = {
        availabilitystatus: this.statusvalue
      }
      axios.post(BaseURL + '/profile/update_user_availability/' + this.user_id, { formData: data }).then(response => {
        console.log(response)
      })
    },
    getZone () {
      const formData = new FormData()
      formData.append('timezone', this.myTimeZone)
      const data = {
        timezone: this.myTimeZone
      }
      axios.post(BaseURL + '/profile/update_user_timezone/' + this.user_id, { formData: data }).then(response => {
        console.log(response)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.btn.removeAvailability{
    background-color: #5bad2b;
  color: #fff;

}
.skilltitle{
  padding: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-content: center;
}
.deleteskillmodal{
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
}
#skilldeletebtn{
  width: 100%;
  height: 100%;
}
.form-check-input:checked {
  background-color: #5bad2b;
  border-color: none;
}

.form-check-input:focus {
  border-color: black;
  outline: 0;
}
.form-check-input:focus {
  border-color: none;
  outline: 0;
  box-shadow: none;
}
input {
  border: none;
  border-radius: 12px !important;
}
.bookTitle {
  text-align: center;
}

.col-lg-10 {
  width: 80%;
  left: 120px;
}
.edit-link {
  text-align: center;
  width: 140px;
  padding-right: 40px;
}
.toggleswitch {
  padding: 15px;
  line-height: 35px;
}
.list {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px;
}
.datelist {
  font-size: 26px;
  display: flex;
  justify-content: start;
  align-items: flex-start;
  color: black;
  font-weight: 400;
}
.timelist {
  margin: 6px;
  display: inline-flexbox;
  flex-wrap: wrap;
  height: 40px;
  width: 260px;
}
.btn {
  background: #f4f4f4;
}
.fa-times:before {
  padding-left: 8px;
  content: "\f00d";
  color: red;
  -webkit-text-stroke: 2.5px #f4f4f4;
}
.sctime {
  font-size: 18px;
  font-weight: 400;
}
.updatetime{
  background: transparent;
  border: none;
  color: black;
  font-size: 20px;
  font-weight: 600;
}
.optionzone {
  display:inline-flex;
    height: 40px;
    position: relative;
    text-align: center;
    font-size: larger;
    font-weight: 700;
    margin:8px;
    right: 10px;
    width: 17%;
}

.myAvailabilitybtn{
    display: flex;
  justify-content: flex-end;

}
#status{
  box-sizing: border-box ;
width: 150px;
  display: flex;
  // flex-wrap: wrap;
  justify-content: space-between;
  align-content: center;
  margin: 13px;
  font-size: 18px;
}
#status,#tmzone{
  display: inline-flex;
  font-size: 16px;
  align-items: center;
  justify-content: flex-end;
  margin: 10px;
  color: black;
  font-weight: 400;

}
select>.getzone{
  color: #5bad2b;
}
// #selectvalue{
//   // color: #5bad2b;
//   // text-align: center;
//   font-size: 16px;
//   font-weight: 400;
// }
#activity{
  display: flex;
  justify-content: flex-end;
  align-items:baseline ;
  align-content: center;
}
.timeupdate{
  background:#f4f4f4
}
.availablityheader{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 12px;
  font-size: 24px;
  font-weight: 400;
}
//toggle button css
.switch {
  position: relative;
  display: inline-flex;
  width: 48px;
  height: 22px;
  justify-content: center;
  align-content: center;
  align-items: center;

}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 2px;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 2px;
  bottom: 3px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #5bad2b;
}

input:focus + .slider {
  box-shadow: 0 0 1px #5bad2b ;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
  @media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
    #activity{
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items:flex-end ;
  align-content: center;
}
    .optionzone {
  display:flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  align-content: space-between;
    height: 40px;
    position: relative;
    text-align: center;
    font-size: larger;
    font-weight: 700;
    margin:5px;
    right: 32px;
    width: 60%;
}
.myAvailabilitybtn{
    display: flex;
  justify-content: center;
}
.datelist{
  display: flex;
  justify-content: center;
}
.timelist {
  display: flex;
  justify-content: center;
  margin: 6px;
  // display: inline-flexbox;
  flex-wrap: wrap;
  height: 40px;
  width: 260px;
}
.listoftimes{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
#status{
  box-sizing: border-box ;
  width: 128px;
  display: flex;
  justify-content: space-between;
  align-content: center;
  margin: 5px;
  font-size: 16px;
}
.availablityheader{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 12px;
  font-size: 24px;
  font-weight: 400;
  margin-top: 30px;
}
  }
  @media only screen and (min-device-width: 481px) and (max-device-width: 768px) {
  .optionzone {
  display:flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  align-content: space-between;
    height: 40px;
    position: relative;
    text-align: center;
    font-size: larger;
    font-weight: 700;
    margin:8px;
    // right: 10px;
    width: 45%;
}
.listoftimes{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.myAvailability{
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
}
}
@media only screen and (min-device-width: 769px) and (max-device-width: 1024px) {
  .optionzone {
  display:flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  align-content: space-between;
    height: 40px;
    position: relative;
    text-align: center;
    font-size: larger;
    font-weight: 700;
    margin:8px;
    // right: 10px;
    width: 20%;
}
}
</style>
